export default __webpack_public_path__ + "static/media/GT-Walsheim-Regular.e7d96dc5.woff";